import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import BarChartIcon from '@mui/icons-material/BarChart';

class ChartToolbar extends Component {
    
    handleOpenPicker = () => {
        this.props.onPickerOpen();
    }
    render() { 
        return ( 
            <React.Fragment>
                <IconButton 
                    onClick={this.handleOpenPicker}
                    size="small"
                    color="default"
                >
                    <BarChartIcon />
                </IconButton>
            </React.Fragment>
         );
    }
}
 
export default ChartToolbar;